import {
  DataLoadingWrapper,
  MultiSectionLayout,
} from "@jugl-web/ui-components";
import React, { useState } from "react";
import { useKnowledgeTraining } from "@web-src/modules/cx/providers/KnowledgeTrainingProvider";
import { AgentKnowledgeMenu } from "./components/AgentKnowledgeMenu";
import { AgentKnowledgeWebsiteContent } from "./components/AgentKnowledgeWebsiteContent";
import { AgentKnowledgeFilesContent } from "./components/AgentKnowledgeFilesContent";
import { AgentTrainingSource } from "./types";
import { AgentKnowledgeTextContent } from "./components/AgentKnowledgeTextContent";
import { AgentKnowledgeQuestionsContent } from "./components/AgentKnowledgeQuestionsContent";
import { useAgentKnowledge } from "../../../../hooks/useAgentKnowledge";

export const KnowledgeTabContent: React.FC<{ entityId: string }> = ({
  entityId,
}) => {
  const {
    isAnyKnowledgeLoading,
    isAnyKnowledgeError,
    handleRetryKnowledge,
    isKnowledgeInfoError,
    isKnowledgeInfoLoading,
    knowledgeInfoRefetch,
  } = useAgentKnowledge(entityId);

  const {
    isTrainingStatusLoading,
    isTrainingStatusError,
    trainingStatusRefetch,
  } = useKnowledgeTraining();

  const [selectedSource, setSelectedSource] = useState<AgentTrainingSource>(
    AgentTrainingSource.website
  );

  return (
    <DataLoadingWrapper
      isLoading={
        isAnyKnowledgeLoading ||
        isTrainingStatusLoading ||
        isKnowledgeInfoLoading
      }
      isError={
        isAnyKnowledgeError || isTrainingStatusError || isKnowledgeInfoError
      }
      onRetry={() => {
        if (isAnyKnowledgeError) {
          handleRetryKnowledge();
        }
        if (isTrainingStatusError) {
          trainingStatusRefetch();
        }
        if (isKnowledgeInfoError) {
          knowledgeInfoRefetch();
        }
      }}
    >
      <MultiSectionLayout
        leftSide={
          <AgentKnowledgeMenu
            entityId={entityId}
            selectedSource={selectedSource}
            onSourceSelect={setSelectedSource}
          />
        }
        classNames={{
          leftSide:
            "flex h-full flex-col overflow-y-auto jugl__custom-scrollbar",
        }}
        className="overflow-y-auto"
      >
        {(() => {
          switch (selectedSource) {
            case AgentTrainingSource.website:
              return <AgentKnowledgeWebsiteContent entityId={entityId} />;
            case AgentTrainingSource.files:
              return <AgentKnowledgeFilesContent entityId={entityId} />;
            case AgentTrainingSource.text:
              return <AgentKnowledgeTextContent entityId={entityId} />;
            case AgentTrainingSource.questions:
              return <AgentKnowledgeQuestionsContent entityId={entityId} />;
            default:
              return null;
          }
        })()}
      </MultiSectionLayout>
    </DataLoadingWrapper>
  );
};
